import useApi from '../../../hooks/use-api'
import useCacheKeys from '../../../hooks/use-cache-keys'
import { useQuery } from 'react-query'
import { get } from 'lodash'

const useDiscussion = ({
    discussionId
}= {}) => {
    const cacheKeys = useCacheKeys()
    const { api, url, endpoints, time } = useApi()
    const { data, isLoading} = useQuery(
        [cacheKeys.DISCUSSIONS, discussionId],
        () => api.get(url(endpoints.discussion, { discussionId })),
        {
            enabled: Boolean(discussionId),
            staleTime: time.MINUTE,
            refetchInterval: time.MINUTE,
            refetchIntervalInBackground: true
        }
    )
    const discussion = data || {}
    const users = get(discussion, 'users', [])

    return {
        isLoading,
        discussion,
        users
    }
}

export default useDiscussion
